const DEBUG = true

const EXCEPTIONS = {
  unknown: {
    name: 'UnkownExceptions',
    msg: 'Es ist ein technischer Fehler aufgetreten - Bitte versuche es später erneut'
  },
  notauthorizedexception: {
    name: 'notauthorizedexception',
    msg: 'notauthorizedexception error',

    incorrectusernameorpassword: {
      name: 'IncorrectUsernameOrPasswordException',
      msg: 'Falscher Benutzername oder Passwort'
    },
    passwordattemptsexceeded: {
      name: 'PasswordAttemptsExceededException',
      msg: 'Passwortversuche überschritten - Bitte versuche es später erneut'
    },
    usercannotbeconfirmedcurrentstatusisconfirmed: {
      name: 'AlreadyConfirmedException',
      msg: 'Benutzer ist bereits bestätigt'
    }
  },
  invalidpasswordexception: {
    name: 'InvalidPasswordException',
    msg: 'Ungültiges Passwort'
  },
  usernameexistsexception: {
    name: 'UsernameExistsException',
    msg: 'Diese E-Mail-Adresse ist bereits vergeben'
  },
  usernotfoundexception: {
    name: 'UserNotFoundException',
    msg: 'Falscher Benutzername oder Passwort'
  },
  /*
  // User will get technical error when these exceptions happen
    codemismatchexception: {
      name: 'CodeMismatchException',
      msg: 'codemismatchexception message'
    }
   */
  limitexceededexception: {
    name: 'LimitExceededException',
    msg: 'Deine Aktion hat das zulässige Limit überschritten. Versuche es später erneut.'
  },
  invalidparameterexception: {
    name: 'InvalidParameterException',
    msg: 'Das gewählte Passwort entspricht nicht den Vorgaben'
  },
  aliasexistsexception: {
    name: 'AliasExistsException',
    msg: 'Diese E-Mail Adresse wird bereits verwendet',
  }
}

/**
 *
 * @param e Exception that was thrown by AWS
 * @return Real exception with translated error text
 */
function handleError(e) {
  let result

  let msg = e.message.toLowerCase()
  msg = msg.replaceAll(' ', '')
  msg = msg.replace(/[^\w\s]|_/g, '')
    .replace(/\s+/g, ' ')
  try {
    result = EXCEPTIONS[e.code.toLowerCase()][msg]
    if (!result) {
      result = EXCEPTIONS[e.code.toLowerCase()]
    }
  } catch (e) {
    result = EXCEPTIONS.unknown
  }

  if (!result) {
    result = EXCEPTIONS.unknown
  }

  if (DEBUG) console.log('finAwsErrorHandler', 'Incoming exception:', e, '/', 'Processed exception', result)
  return result
}

export {handleError}
